import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import isNode from 'detect-node'
import { registerDrawer } from 'utils/drawerController'

const ClientDrawerProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [Content, setContent] = useState(null)

  useEffect(() => {
    registerDrawer(
      (component, props) => {
        setContent(component)
        setIsOpen(true)
      },
      () => setIsOpen(false),
    )
  }, [])

  return (
    <>
      {children}
      {isOpen &&
        ReactDOM.createPortal(
          <div id="scope" className="fixed inset-0 z-[9999] flex justify-end">
            <div
              className="fixed inset-0 bg-black/40"
              onClick={() => setIsOpen(false)}
            />
            <aside
              className="
            bg-white shadow-2xl flex flex-col 
            fixed bottom-0 left-0 right-0 rounded-t-2xl max-h-full
            md:relative md:h-full md:w-120 md:rounded-none
          "
            >
              <div className="flex-1 overflow-y-auto">{Content}</div>
            </aside>
          </div>,
          document.body,
        )}
    </>
  )
}

export const DrawerProvider = ({ children }) => {
  if (isNode) {
    return <>{children}</>
  }

  return <ClientDrawerProvider>{children}</ClientDrawerProvider>
}
